module.exports = __webpack_public_path__ + "img/MA3D-Standard.1414f204.png";